import { UpdateOrganizationProposalContentMutationVariables } from "generated/graphql";
import useUpdateOrganizationProposalContent from "hooks/organization/useUpdateOrganizationPropoposalContent";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import ProposalSettingsList from "modules/ProposalSettingsList/ProposalSettingsList";
import { useCallback, useRef } from "react";
import PageTour, { PageTourHandle } from "components/PageTour/PageTour";
import proposalSettingsPageTourSteps from "./ProposalSettingsPage.tour";

export default function ProposalSettingsPage() {
  const [updateProposalSettings, { loading, error, getData, isSuccess }] =
    useUpdateOrganizationProposalContent();
  const tourRef = useRef<PageTourHandle>(null);

  const onSubmit = useCallback(
    async (variables: UpdateOrganizationProposalContentMutationVariables) => {
      const result = await updateProposalSettings({ variables });
      const success = isSuccess(result.data);
      const data = getData(result);
      return { success, data };
    },
    [updateProposalSettings]
  );
  return (
    <DashboardLayout>
      <PageTour
        ref={tourRef}
        tourKey="proposalSettingsPage"
        steps={proposalSettingsPageTourSteps}
      />
      <ProposalSettingsList
        onSubmit={onSubmit}
        loading={loading}
        onHelpClick={() => tourRef.current?.replay()}
      />
    </DashboardLayout>
  );
}
